import React, { useState, useEffect } from "react";
import {
  FaBars,
  FaTimes,
  FaHome,
  FaProjectDiagram,
  FaInfoCircle,
  FaEnvelope,
  FaBriefcase,
  FaChartLine,
  FaChalkboardTeacher,
} from "react-icons/fa";
import { GiSkills, GiTrophyCup } from "react-icons/gi";
import "./Navbar.css";

// section ids must match the <section id="..."> on the page
const NAV = [
  { id: "home", label: "Home", icon: <FaHome className="icon" /> },
  { id: "about", label: "About", icon: <FaInfoCircle className="icon" /> },
  { id: "skills", label: "Skillsets", icon: <GiSkills className="icon" /> },
  { id: "experience", label: "Experience", icon: <FaBriefcase className="icon" /> },
  { id: "activity", label: "Activity", icon: <FaChartLine className="icon" /> },
  { id: "projects", label: "Projects", icon: <FaProjectDiagram className="icon" /> },
  { id: "mentorship", label: "Mentor", icon: <FaChalkboardTeacher className="icon" /> },
  { id: "achievements", label: "Achievements", icon: <GiTrophyCup className="icon" /> },
  { id: "contact", label: "Contact", icon: <FaEnvelope className="icon" /> },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState("home");

  const closeMenu = () => setIsOpen(false);

  // smooth scroll to a section
  const goTo = (id) => {
    closeMenu();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // highlight the section currently in view
  useEffect(() => {
    const ids = NAV.map((n) => n.id);
    const onScroll = () => {
      let current = "home";
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 120) current = id;
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <span className="nav-brand" onClick={() => goTo("home")}>
          model_card<span className="nav-dot">.</span>md
        </span>

        <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={`nav-links ${isOpen ? "active" : ""}`}>
          {NAV.map((n) => (
            <li key={n.id}>
              <button
                className={`nav-btn ${active === n.id ? "is-active" : ""}`}
                onClick={() => goTo(n.id)}
              >
                {n.icon} <span>{n.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;